"use strict";

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupManager = exports.Group = void 0;

var Endpoints_1 = require("../Endpoints");

var base_1 = require("./base");

var Group = /*#__PURE__*/function () {
  function Group(rest, data) {
    _classCallCheck(this, Group);

    this.rest = rest;
    this.categories = data.categories;
    this.icon = data.icon;
    this.members = data.members;
    this.name = data.name;
  }
  /**
   * Adds a new member.
   * @param username The member to add.
   */


  _createClass(Group, [{
    key: "addMember",
    value: function addMember(username) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rest.performRequest(Endpoints_1.Endpoints.groupMember(this.name, username), {
                  method: 'put'
                });

              case 2:
                // Add members cache to this instance.
                this.members.push(username);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return Group;
}();

exports.Group = Group;

var GroupManager = /*#__PURE__*/function (_base_1$BaseManager) {
  _inherits(GroupManager, _base_1$BaseManager);

  var _super = _createSuper(GroupManager);

  function GroupManager() {
    _classCallCheck(this, GroupManager);

    return _super.apply(this, arguments);
  }

  _createClass(GroupManager, [{
    key: "create",
    value:
    /**
     * Creates a new group.
     * @param group The data to create a group.
     */
    function create(group) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.rest.performRequest(Endpoints_1.ModelBases.group, {
                  method: 'post',
                  body: JSON.stringify(group)
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Looks up a specific group.
     * @param name The name of the group to get.
     * @returns The found group or undefined if not found.
     */

  }, {
    key: "get",
    value: function get(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.rest.performRequest(Endpoints_1.Endpoints.specificGroup(name)).catch(function (e) {
                  if (e.code === 404) {
                    return undefined;
                  }

                  throw e;
                });

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Update the given group.
     * @param groupName The group name to update.
     * @param data The data to update the group with.
     */

  }, {
    key: "update",
    value: function update(groupName, data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.rest.performRequest(Endpoints_1.Endpoints.specificGroup(groupName), {
                  method: 'put',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data)
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return GroupManager;
}(base_1.BaseManager);

exports.GroupManager = GroupManager;